import _debounce from 'lodash.debounce';
import { useEffect, useState } from 'react';
import { BREAKPOINTS } from '../Constants';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < BREAKPOINTS.lg);

  useEffect(() => {
    const handleResize = _debounce(() => {
      const currentlyMobile = window.innerWidth < BREAKPOINTS.lg;
      setIsMobile((prev) => {
        if (prev !== currentlyMobile) {
          return currentlyMobile;
        }
        return prev; // no state update → no re-render
      });
    }, 100);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { isMobile };
};
